const $ = jQuery;

class VideoEmbed {
	constructor() {
		this.triggers = document.querySelectorAll('.video-embed .video-embed__play');
	}

	init() {
		this.triggers.forEach( trigger => {
            trigger.addEventListener( 'click', this.handlePlayClick.bind( this ) );
        })
	}
    
    handlePlayClick( e ) {
        const parent = e.currentTarget.closest('.video-embed');
        const iframe = parent.querySelector('iframe');

        parent.classList.add('video-embed--active');

        const lazySrc = iframe.getAttribute('lazy-src');
        if ( lazySrc ) {
            iframe.src = `${lazySrc}&autoplay=1&loop=1&wmode=transparent&rel=0`;
        }
    }
}

export default new VideoEmbed;